import React from "react";
import { Collapse } from "react-collapse";
import SpeedSelectButton from "./SpeedSelectButton";
import { PLAYBACK_SPEED_CONTROL_HEIGHT } from "../../config";
import ColourCurveSelect from "./ColourCurveSelect";

function PanelSettings(props) {
  let colourCurve = "";
  let temperatureDisplayButton = null;
  if (
    props.colourCurve &&
    props.colourCurve.options &&
    props.colourCurve.options.list &&
    props.colourCurve.options.list.length > 0
  ) {
    colourCurve = (
      <ColourCurveSelect
        activeImageId={props.activeImageId}
        colourCurve={props.colourCurve}
      />
    );
  }

  if (props.temperatureDisplayScale) {
    temperatureDisplayButton = (
      <button
        className={
          props.temperatureDisplayEnabled
            ? "btn temperature-scale active"
            : "btn temperature-scale "
        }
        onClick={props.updateTemperatureDisplay}
      >
        &nbsp;
      </button>
    );
  }

  return (
    <Collapse
      isOpened={props.panelOptions.isOpen}
      fixedHeight={PLAYBACK_SPEED_CONTROL_HEIGHT}
    >
      <SpeedSelectButton
        playbackSpeed={props.playbackSpeed}
        panelId={props.panelId}
        speedModifier={1}
      />
      <SpeedSelectButton
        playbackSpeed={props.playbackSpeed}
        panelId={props.panelId}
        speedModifier={2}
      />
      <SpeedSelectButton
        playbackSpeed={props.playbackSpeed}
        panelId={props.panelId}
        speedModifier={4}
      />
      {temperatureDisplayButton}
      {colourCurve}
    </Collapse>
  );
}

export default PanelSettings;
